import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HTTPAPIConfig, APIConfigMapping, VlDataService, VlHttpService } from 'shared-library';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../environments/environment';
import { LoginService } from 'usermgmt';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  
  private contentSubject = new BehaviorSubject<string>('dashboard');
  content$ = this.contentSubject.asObservable();

  private projectListSource = new BehaviorSubject<any[]>([]);
  projectList$ = this.projectListSource.asObservable();

  constructor(   private dataService: VlDataService,
    private httpService: VlHttpService,
    private keycloak: KeycloakService,
    private loginService: LoginService,
  ) { }

  updateContent(content: string) {
    this.contentSubject.next(content);
  }

  updateProjectList(projectList: any[]) {
    this.projectListSource.next(projectList);
  }

  async createAllDefaultPages(applicationId: string, defaultPageJson: any, landingPageNavConfig?: any): Promise<any> {
    return await new Promise((resolve, reject) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_MASTER_PAGES']);
      apiConfig.postData = {
        applicationId: applicationId,
        defaultPages: defaultPageJson,
      };
      if (landingPageNavConfig) {
        apiConfig.postData['landingPageNavConfig'] = landingPageNavConfig
      }
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          resolve(data);
        },
        error: (err: any) => {
          reject(err);
        }
      })
    })
  }

  async getAllDefaultPages(applicationTypeId: string): Promise<any> {
    return await new Promise((resolve, reject) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_MASTER_PAGES']);
      apiConfig.postData = { application_type_id: applicationTypeId };
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          resolve(data);
        },
        error: (err: any) => {
          reject(err);
        }
      })
    })
  }

  async reinitializeKeycloak(isLoggedIn:boolean): Promise<void> {
     try {
       if (isLoggedIn) {
         await this.keycloak.logout(environment.KEYCLOAK_URLS.LOGOUT_URL); // Log out if logged in
        }
        // Reinitialize Keycloak with new realm and clientId
        await this.keycloak.init({
        config: {
          realm: environment.REALM_NAME,
          clientId: environment.CLIENT_ID,
          url: environment.KEYCLOAK_URLS.BASE_URL,
        
        },
        initOptions: {
          onLoad: 'check-sso',
          checkLoginIframe: true,
          checkLoginIframeInterval: 100,
          silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
          redirectUri:environment.KEYCLOAK_URLS.REDIRECT_URL
        }
      });

          // this.route.navigate(['','landing-page']);
       this.loginService.initiateLogin();

    } catch (error) {
      console.error("Error during Keycloak reinitialization:", error);
    }
  }
}
